import * as Types from 'actions/types';

const defaultState = {
  appID: null,
  form: null,
  config: true,
  detectedBrowser: null
}

export default function (state = defaultState, action){
  switch(action.type){
    case Types.TOGGLE_FORM_MODAL:
      return { ...state, appID: action.payload.appID, form: action.payload.form, config: true, detectedBrowser: null };
    case Types.POST_INSTALL_REQUIRED:
      return { ...state, appID: action.payload.appID, config: action.payload.config, detectedBrowser: action.payload.browser, form: 'configure' };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/ui.js